import { Context } from '@alltrails/shared/types/context';
import FooterWrapper from 'components/FooterWrapper';
import NavigationWrapper from 'components/NavigationWrapper';
import { PropsWithChildren } from 'react';

type Props = {
  context: Context;
  currentPage: string;
  locationSlug: string;
  wideFooter: boolean;
};

export default function ApplicationLayout({ currentPage, children, locationSlug, context, wideFooter }: PropsWithChildren<Props>) {
  return (
    <>
      <div id="header">
        <NavigationWrapper context={context} currentPage={currentPage} locationSlug={locationSlug} />
      </div>
      {children}
      <FooterWrapper context={context} wideFooter={wideFooter} />
    </>
  );
}
